import * as React from "react";
import classnames from "classnames";
/* empty css                 */
const renderProgressBar = (max, value) => /* @__PURE__ */ React.createElement("progress", { className: "progress-bar__value", max, value }, value && `${value}%`);
const ProgressBar = ({ label, max, value, className }) => /* @__PURE__ */ React.createElement("div", { className: classnames("progress-bar", className), "data-t": "progress-bar" }, label ? /* @__PURE__ */ React.createElement("label", { className: "progress-bar__label" }, label, renderProgressBar(max, value)) : renderProgressBar(max, value));
export {
  ProgressBar as default
};
//# sourceMappingURL=ProgressBar.js.map
